// extracted by mini-css-extract-plugin
export default {"root":"ScreenError_root__otosc","icon":"ScreenError_icon__ebrUZ","message":"ScreenError_message__bWy98"};